import { apiFetch } from './client';
import type { AuthMeData } from '../types/api';

export function fetchMe() {
  return apiFetch<AuthMeData>('/api/auth/me', { silentOn401: true });
}

export function logout() {
  return apiFetch<Record<string, never>>('/api/auth/logout', { method: 'POST' });
}
